import React from 'react';
import { Box, Tooltip, Fab } from '@mui/material';
import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components/data-grid/DataGridToolbar';
import { transportSeatsControlColumns } from '../../../../services/column-definitions';
import { TransportSeatsDetails } from './TransportSeatsDetails';
import AddIcon from '@mui/icons-material/Add';

export function TransportSeatsList(props) {
  const { onOpenSidebar, hideSidebar, transports, queryCallback, loading, submitCallback, allResorts, allSeasons } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);

  const handleDetailsCheck = (data, doubleClick = false) => {
    setEditRowData(data);
    if (doubleClick) {
      setFullScreen(true);
    }
    setOpenCompose(true);
  };

  return <Box sx={{ opacity: loading ? 0.5 : 1, height: '100%' }}>
    <TransportSeatsDetails
      isOpenCompose={openCompose}
      parentFullScreen={fullScreen}
      onCloseCompose={() => {
        setOpenCompose(false);
        setFullScreen(false);
        setEditRowData(null);
      }}
      submitCallback={submitCallback}
      data={editRowData}
      allSeasons={allSeasons}
      allResorts={allResorts}
    />
    <Box display="flex" justifyContent="center">
      <Tooltip title="Dodaj diete" sx={{ mb: 1 }}>
        <Fab
          color="primary"
          aria-label="add"
          onClick={() => {
            setFullScreen(true);
            setOpenCompose(true);
          }}
        >
          <AddIcon style={{ fontSize: '30px' }} />
        </Fab>
      </Tooltip>
    </Box>
    <Box sx={{ minWidth: { md: 1200 }, height: '100%' }}>
      <DataGridPro
        columns={transportSeatsControlColumns(handleDetailsCheck)}
        rows={transports}
        density="compact"
        disableColumnMenu={true}
        autoPageSize={false}
        // autoHeight={true}
        rowsPerPageOptions={[10, 25, 50, 100]}
        pagination
        components={{
          Toolbar: DataGridToolbar
        }}
        componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: false } }}
        localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
        disableSelectionOnClick
        onRowDoubleClick={params => handleDetailsCheck(params.row, true)}
        onRowClick={params => {
          setEditRowData(params.row);
          setFullScreen(true);
          setOpenCompose(true);
        }}
      />
    </Box>
  </Box>;
}
